import Avatar from "./Avatar";
import common from "./common";
import moment from "moment";

export default class SaveData {
    constructor() {
        this._data = null;

        this.loadGame();
    }

    newGame() {
        this._data = {};
        this._data.users = [
            this.createUser(0),
            this.createUser(1),
            this.createUser(2)
        ];
        this.saveGame();
    }

    saveGame() {
        const name = common.config.save.name + common.config.save.version;
        if (!common.config.game.debug_legacy_save) {
            common.gmi.setGameData(name, this._data);
        } else {
            window.localStorage.setItem(name, JSON.stringify(this._data));
        }
    }

    loadGame() {
        const name = common.config.save.name + common.config.save.version;
        const settings = common.gmi.getAllSettings();

        if (!common.config.game.debug_legacy_save) {
            this._data = settings.gameData ? settings.gameData[name] : null;
        } else {
            this._data = window.localStorage.getItem(name);
        }

        this.convertSave();

        if (!this._data || !this._data.users) {
            this.newGame();
            return false;
        }
        return true;
    }

    unlockRandomItem() {
        const user = this.getUserData(common.userId);
        let items = P3.utils.objectToArray(P3.assets.json("equipment")).filter(
            x => x.enabled && x.locked && ((user.unlock[x.slot] && user.unlock[x.slot].indexOf(x.type) === -1) || !user.unlock[x.slot]));

        const priority = items.filter(x => x.priority);
        if (priority.length > 0) {
            items = priority;
        }

        if (items.length > 0) {
            const unlock = P3.utils.selectRandom(items);
            if (!user.unlock[unlock.slot]) {
                user.unlock[unlock.slot] = [unlock.type];
            } else {
                user.unlock[unlock.slot].push(unlock.type);
            }
            this.saveGame();

            console.log("unlocked new item:", unlock.slot, unlock.type);

            // tracking
            common.gmi.sendStatsEvent("item", "unlock", {
                metadata: "IID=" + unlock.slot + unlock.type
            });
            return unlock;
        }
        console.log("no items to unlock");
        return null;
    }

    createUser(id) {
        return {
            id: id,
            class: Avatar.CLASS_KNIGHT_1,
            xp: 0,
            totalXp: 0,
            level: 0,
            location: 0,
            difficulty: {},
            loot: false,
            equipment: {},
            unlock: {},
            finishedTraining: false,
            showKeypad: PIXI.utils.isMobile.any,
            battlecardsLearned: false,
            achievements: {},
            victory: 0,
            bosses: {},
            timestamp: 0,
            streak: {},
            week: "",
            orbs: 0,
        };
    }

    convertSave()
    {
        let count = 0;

        if (this._data && this._data.users)
        {
            for (const i in this._data.users)
            {
                if (this._data.users.hasOwnProperty(i))
                {
                    const user = this._data.users[i];
                    if (!user.achievements)
                    {
                        user.achievements = {};
                        user.victory = 0;
                        user.bosses = {};
                        user.timestamp = 0;
                        user.streak = {};
                        user.week = "";
                        user.orbs = 0;
                        ++count;
                    }
                }
            }
        }

        if (count > 0)
        {
            this.saveGame();
            console.warn("Save converted to support achievements!");
        }
    }

    resetUserData(id) {
        this._data.users[id] = this.createUser(id);
        this.saveGame();

        console.log("user", id, "reset");
    }

    getUserData(id) {
        return this._data.users[id];
    }

    getUserDifficultyLevel(id, location) {
        if (common.config.game.debug_level === -1)
        {
            return this.getUserData(id).difficulty[location] || 0;
        }
        else
        {
            return P3.math.clamp(common.config.game.debug_level, 1, 4);
        }
    }

    setUserDifficultyLevel(id, location, value) {
        const user = this.getUserData(id);
        user.difficulty[location] = value;
        this.saveGame();
    }

    getUserPetId(id) {
        const user = this.getUserData(id);
        return user.equipment.pet ? user.equipment.pet : -1;
    }

    completeWeeklyChallenge(id)
    {
        const user = this.getUserData(id);
        const timestamp = common.week + "_" + common.year;

        if (user.week !== timestamp)
        {
            user.week = timestamp;
            ++user.orbs;
            this.saveGame();

            return true;
        }
        return false;
    }

    isWeeklyChallengeComplete(id)
    {
        const user = this.getUserData(id);
        const timestamp = common.week + "_" + common.year;

        return user.week === timestamp;
    }
}